import React from "react";
import AttorneyInformationBase from "../../shared/components/AttorneyInformationBase";
import { ATTORNEY_INFO_CONFIG } from "../../shared/attorneyInformationConfig";
import { BOND_STEP_ATTORNEY_GUARDIANSHIP } from "../../shared/bondWizardStepPropTypes";

const AttorneyInformation = ({
  globalData,
  data,
  updateData,
  errors,
  isGuest,
}) => (
  <AttorneyInformationBase
    cfg={ATTORNEY_INFO_CONFIG.guardianship}
    globalData={globalData}
    data={data}
    updateData={updateData}
    errors={errors}
    isGuest={isGuest}
  />
);

AttorneyInformation.propTypes = BOND_STEP_ATTORNEY_GUARDIANSHIP;

export default AttorneyInformation;
